import { useEffect } from 'react'
import { defineMessages, useIntl, FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'

import Heading from 'components/v2/Heading'
import { Content, ContentBody, ContentHeader } from 'components/v2/Content'
import { sanitizeDateRange } from 'features/App/components/Filters/DateRangeFilter'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { withInventoryWastes } from 'features/Inventories/components/WithInventoryWastes'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { sanitizeInventory } from 'resolvers/inventories'
import { getQueries } from 'utils/route'
import { canReadInventory, canReadCart } from 'features/Users/utils'
import { WastesFilters } from './Filters'
import { WastesList } from './List'
import { WastesPagination } from './Pagination'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'wastes.helmet',
    defaultMessage: 'Wastes | Nexbus Admin'
  }
})

const Wastes = withInventoryWastes(WastesList, WastesPagination)

const WastesView = (): TSFixMe => {
  const location = useLocation()
  const intl = useIntl()
  const login = useLogin()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  if (!(canReadInventory(login.accessToken.policies) || canReadCart(login.accessToken.policies))) {
    return <ForbiddenView feature={FEATURES.INVENTORY} />
  }

  let {
    page = 1,
    // eslint-disable-next-line prefer-const
    inventoryId,
    // eslint-disable-next-line prefer-const
    id = '',
    // eslint-disable-next-line prefer-const
    creationDateFrom,
    // eslint-disable-next-line prefer-const
    creationDateTo,
    // eslint-disable-next-line prefer-const
    creationDateRangeValue
  } = getQueries(location.search)

  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  page = parseInt(page)

  const companyId = login.accessToken.companyId
  const sanitizedInventory = sanitizeInventory(inventoryId, companyId)
  const sanitizedCreationDateRange = sanitizeDateRange({
    from: creationDateFrom,
    to: creationDateTo,
    rangeValue: creationDateRangeValue
  })

  const filters = {
    id,
    inventory: sanitizedInventory,
    creationDateRange: sanitizedCreationDateRange
  }

  return (
    <Content>
      <ContentHeader isResponsive>
        <Heading.H3>
          <FormattedMessage id="spanish.wastes.header.label" defaultMessage="Lista de merma" />
        </Heading.H3>
      </ContentHeader>
      <ContentBody>
        <WastesFilters filters={filters} companyId={companyId} />
        <Wastes
          page={page}
          urls={{
            list: '/wastes',
            new: canReadInventory(login.accessToken.policies) ? '/inventories' : '/carts'
          }}
          filters={filters}
        />
      </ContentBody>
    </Content>
  )
}

export default withLastUrl(WastesView)
